import React from 'react'

const Jva_cs = () => {
    return (
        <div className='container'> 
        <h1 class="h1">Java If-else Statement</h1>
        <p>The Java <em>if statement</em> is used to test the condition. It checks boolean condition: <em>true</em> or
           <em>false</em>. There are various types of if statement in Java.
        </p>
        <ul class="points">
           <li>if statement</li>
           <li>if-else statement</li>
           <li>if-else-if ladder</li>
           <li>nested if statement</li>
        </ul>
     
        <h2 class="h2">Java if Statement</h2>
        <p>The Java if statement tests the condition. It executes the <em>if block</em> if condition is true.</p>
     
        <p><strong>Syntax:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span class="keywords">if</span><span>(condition)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span><span
                          class="comment">//code&nbsp;to&nbsp;be&nbsp;executed</span><span>&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
     
        </div>
     
        <p><strong>Example:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span
                          class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstate&nbsp;the&nbsp;use&nbsp;of&nbsp;if&nbsp;statement.</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;IfExample&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//defining&nbsp;an&nbsp;'age'&nbsp;variable</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">int</span><span>&nbsp;age=</span><span
                          class="string">20</span><span>;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//checking&nbsp;the&nbsp;age</span><span>&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">if</span><span>(age&gt;</span><span
                          class="string">18</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(<span
                          class="string">"Age&nbsp;is&nbsp;greater&nbsp;than&nbsp;18"</span><span>);&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
     
        </div>
        
        <p>Output:</p>
        <div class="output">
           <pre>Age is greater than 18
        </pre>
        </div>
     
        <h2 class="h2">Java if-else Statement</h2>
        <p>The Java if-else statement also tests the condition. It executes the <em>if block</em> if condition is true
           otherwise <em>else block</em> is executed.</p>
     
        <p><strong>Syntax:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 <div class="tools">
                 </div>
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt">
                    <span><span class="keywords">if</span><span>(condition)&#123;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span
                          class="comment">//code&nbsp;if&nbsp;condition&nbsp;is&nbsp;true</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&#125;<span class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span><span
                          class="comment">//code&nbsp;if&nbsp;condition&nbsp;is&nbsp;false</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
     
        </div>
       
     
        <p><strong>Example:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span
                          class="comment">//A&nbsp;Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;use&nbsp;of&nbsp;if-else&nbsp;statement.</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span
                          class="comment">//It&nbsp;is&nbsp;a&nbsp;program&nbsp;of&nbsp;odd&nbsp;and&nbsp;even&nbsp;string.</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;IfElseExample&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//defining&nbsp;a&nbsp;variable</span><span>&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">int</span><span>&nbsp;string=</span><span
                          class="string">13</span><span>;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//Check&nbsp;if&nbsp;the&nbsp;string&nbsp;is&nbsp;divisible&nbsp;by&nbsp;2&nbsp;or&nbsp;not</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">if</span><span>(string%</span><span
                          class="string">2</span><span>==</span><span
                          class="string">0</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"even&nbsp;string"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span
                          class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"odd&nbsp;string"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        </div>
        
        <p>Output:</p>
        <div class="output">
           <pre>odd string
        </pre>
        </div>
     
        <p><strong>Leap Year Example:</strong></p>
        <p>A year is leap, if it is divisible by 4 and 400. But, not by 100.</p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;LeapYearExample&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">int</span><span>&nbsp;year=</span><span
                          class="string">2020</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">if</span><span>(((year&nbsp;%&nbsp;</span><span
                          class="string">4</span><span>&nbsp;==</span><span
                          class="string">0</span><span>)&nbsp;&amp;&amp;&nbsp;(year&nbsp;%&nbsp;</span><span
                          class="string">100</span><span>&nbsp;!=</span><span
                          class="string">0</span><span>))&nbsp;||&nbsp;(year&nbsp;%&nbsp;</span><span
                          class="string">400</span><span>==</span><span
                          class="string">0</span><span>))&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"LEAP&nbsp;YEAR"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"COMMON&nbsp;YEAR"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        </div>
        <p>Output:</p>
        <div class="output">
           <pre>LEAP YEAR
        </pre>
        </div>
     
        <h2 class="h2">Using Ternary Operator</h2>
        <p>We can also use ternary operator (? :) to perform the task of if...else statement. It is a shorthand way to check
           the condition. If the condition is true, the result of ? is returned. But, if the condition is false, the result
           of : is returned.</p>
        <p><strong>Example:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;IfElseTernaryExample&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">int</span><span>&nbsp;string=</span><span
                          class="string">13</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//Using&nbsp;ternary&nbsp;operator</span><span>&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;String&nbsp;output=(string%<span
                          class="string">2</span><span>==</span><span class="string">0</span><span>)?</span><span
                          class="string">"even&nbsp;string"</span><span>:</span><span
                          class="string">"odd&nbsp;string"</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(output);&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        </div>
        <p>Output:</p>
        <div class="output">
           <pre>odd string
        </pre>
        </div>
     
        <h2 class="h2">Java if-else-if ladder Statement</h2>
        <p>The if-else-if ladder statement executes one condition from multiple statements.</p>
     
        <p><strong>Syntax:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span class="keywords">if</span><span>(condition1)&#123;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span
                          class="comment">//code&nbsp;to&nbsp;be&nbsp;executed&nbsp;if&nbsp;condition1&nbsp;is&nbsp;true</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&#125;<span class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(condition2)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span><span
                          class="comment">//code&nbsp;to&nbsp;be&nbsp;executed&nbsp;if&nbsp;condition2&nbsp;is&nbsp;true</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span><span class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(condition3)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span><span
                          class="comment">//code&nbsp;to&nbsp;be&nbsp;executed&nbsp;if&nbsp;condition3&nbsp;is&nbsp;true</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>...&nbsp;&nbsp;</span></li>
                 <li class=""><span><span class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span><span
                          class="comment">//code&nbsp;to&nbsp;be&nbsp;executed&nbsp;if&nbsp;all&nbsp;the&nbsp;conditions&nbsp;are&nbsp;false</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        </div>

     
        <p><strong>Example:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span
                          class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;use&nbsp;of&nbsp;If&nbsp;else-if&nbsp;ladder.</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span
                          class="comment">//It&nbsp;is&nbsp;a&nbsp;program&nbsp;of&nbsp;grading&nbsp;system&nbsp;for&nbsp;fail,&nbsp;D&nbsp;grade,&nbsp;C&nbsp;grade,&nbsp;B&nbsp;grade,&nbsp;A&nbsp;grade&nbsp;and&nbsp;A+.</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;IfElseIfExample&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">int</span><span>&nbsp;marks=</span><span
                          class="string">65</span><span>;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">if</span><span>(marks&lt;</span><span
                          class="string">50</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"fail"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(marks&gt;=</span><span
                          class="string">50</span><span>&nbsp;&amp;&amp;&nbsp;marks&lt;</span><span
                          class="string">60</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"D&nbsp;grade"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(marks&gt;=</span><span
                          class="string">60</span><span>&nbsp;&amp;&amp;&nbsp;marks&lt;</span><span
                          class="string">70</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"C&nbsp;grade"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(marks&gt;=</span><span
                          class="string">70</span><span>&nbsp;&amp;&amp;&nbsp;marks&lt;</span><span
                          class="string">80</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"B&nbsp;grade"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(marks&gt;=</span><span
                          class="string">80</span><span>&nbsp;&amp;&amp;&nbsp;marks&lt;</span><span
                          class="string">90</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"A&nbsp;grade"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span
                          class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(marks&gt;=</span><span
                          class="string">90</span><span>&nbsp;&amp;&amp;&nbsp;marks&lt;</span><span
                          class="string">100</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"A+&nbsp;grade"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span
                          class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"Invalid!"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        </div>
     
        <p>Output:</p>
        <div class="output">
           <pre>C grade
        </pre>
        </div>
     
        <p><strong>Program to check POSITIVE, NEGATIVE or ZERO:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;PositiveNegativeExample&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">int</span><span>&nbsp;string=-</span><span
                          class="string">13</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">if</span><span>(string&gt;</span><span
                          class="string">0</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"POSITIVE"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span class="keywords">else</span><span>&nbsp;</span><span
                          class="keywords">if</span><span>(string&lt;</span><span
                          class="string">0</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"NEGATIVE"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span
                          class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"ZERO"</span><span>);&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        </div>
        <p>Output:</p>
        <div class="output">
           <pre>NEGATIVE
        </pre>
        </div>
     
        <h2 class="h2">Java Nested if statement</h2>
        <p>The nested if statement represents the <em>if block within another if block</em>. Here, the inner if block
           condition executes only when outer if block condition is true.
        </p>
     
        <p><strong>Syntax:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span
                          class="keywords">if</span><span>(condition)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//code&nbsp;to&nbsp;be&nbsp;executed&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">if</span><span>(condition)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//code&nbsp;to&nbsp;be&nbsp;executed&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
     
        </div>
      
     
        <p><strong>Example:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span
                          class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;use&nbsp;of&nbsp;Nested&nbsp;If&nbsp;Statement.</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;JavaNestedIfExample&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//Creating&nbsp;two&nbsp;variables&nbsp;for&nbsp;age&nbsp;and&nbsp;weight</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">int</span><span>&nbsp;age=</span><span
                          class="string">20</span><span>;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">int</span><span>&nbsp;weight=</span><span
                          class="string">80</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//applying&nbsp;condition&nbsp;on&nbsp;age&nbsp;and&nbsp;weight</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">if</span><span>(age&gt;=</span><span
                          class="string">18</span><span>)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">if</span><span>(weight&gt;</span><span
                          class="string">50</span><span>)&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"You&nbsp;are&nbsp;eligible&nbsp;to&nbsp;donate&nbsp;blood"</span><span>);&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        </div>
        
        <p>Output:</p>
        <div class="output">
           <pre>You are eligible to donate blood
        </pre>
        </div>
     
        <p><strong>Example 2:</strong></p>
        <div class="containers">
           <div class="dp-highlighter">
              <div class="bar">
                 
              </div>
              <ol start="1" class="dp-j">
                 <li class="alt"><span><span
                          class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;use&nbsp;of&nbsp;Nested&nbsp;If&nbsp;Statement.&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">class</span><span>&nbsp;JavaNestedIfExample2&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                          class="keywords">static</span><span>&nbsp;</span><span
                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//Creating&nbsp;two&nbsp;variables&nbsp;for&nbsp;age&nbsp;and&nbsp;weight&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">int</span><span>&nbsp;age=</span><span
                          class="string">25</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">int</span><span>&nbsp;weight=</span><span
                          class="string">48</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="comment">//applying&nbsp;condition&nbsp;on&nbsp;age&nbsp;and&nbsp;weight&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="keywords">if</span><span>(age&gt;=</span><span
                          class="string">18</span><span>)&#123;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                          class="keywords">if</span><span>(weight&gt;</span><span
                          class="string">50</span><span>)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
                 <li class="">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"You&nbsp;are&nbsp;eligible&nbsp;to&nbsp;donate&nbsp;blood"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;<span
                          class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"You&nbsp;are&nbsp;not&nbsp;eligible&nbsp;to&nbsp;donate&nbsp;blood"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                 </li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;<span
                          class="keywords">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                 <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                          class="string">"Age&nbsp;must&nbsp;be&nbsp;greater&nbsp;than&nbsp;18"</span><span>);&nbsp;&nbsp;</span></span>
                 </li>
                 <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                 <li class="alt"><span>&#125;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
              </ol>
           </div>
        
        
        </div>
                </div>
    )
        }

export default Jva_cs
